module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Avengers-Infinity-Wars.caf3d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Avengers-Infinity-Wars.jpg
// module id = 3Sus
// module chunks = 0